class DropingPointModel {
    droppingpointId?: number;
    code?: string;
    name?: string;
    address?: string;
    pincode?: string;
    landmark?: string;
    agentId?: number;
    firstName?: string;
    isActive?: boolean;
    morningRouteId?: number;
    morningRouteName?: string;
    morningRouteOrder?:number;
    eveningRouteId?: number;
    eveningRouteName?: string;
    eveningRouteOrder?:number;
    areaId? :number;
    areaName?: string;
    latitude?: string;
    longitude?: string;
    constituencyId?: number;
    constituencyName?: string;
    wardId?: number;
    wardName?: string;
    zoneId?: number;
    zoneName?: string;
    districtId?: number;
    districtName?: string;
    stateId?:number;
    stateName?:string;
    talukId?:number;
    talukName?:string;
    unionId?:number;
    unionName?:string;
    minimumOrderQuantity?: string;
    maximumOrderQuantity?: string;
    creditLimit?: string;
    accountCode?: string;
    isOtherState?:boolean;
    type?:number;
    gstIn?:string;
    categoryId:number;
    categoryName? : String;
  
}
export default DropingPointModel;
